import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import Modal from '../../../../components/Modal/Modal';
import { BackButton } from '../../../../components';
import { Block } from '../../../../../../components';
import CardPayment from '../../Reincorporation/progress/components/CardPayment';
import Step from '../../UpdatePhoto/Register/components/Step';
import constants from '../../../../constants';
import Spinner from '@/presentation/components/Spinner';
import Processing from '@/presentation/components/Processing';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import { ProcedureInfoComponent } from '../info/components/ProcedureinfoComponent';
import ButtonCancelRequest from '@/presentation/components/ButtonCancelRequest';
import CancelProcedure from '../../CertificateOfStudies/dialogs/CancelProcedure';
import PaymentCreated from '../../CertificateOfStudies/dialogs/PaymentCreated';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import AnulledFinalState from './components/AnulledFinalState';
import ModalAnulled from './components/ModalAnulled';

interface Props {
  handlerBackButton: () => void;
  request: any;
  procedure: any;
  procedureSelectedInfo: any;
  isLoadingStatus: boolean;
  isLoadingDetail: boolean;
  isActivating: boolean;
  isLoadingDelete: boolean;
  handlerActivatePayment: () => void;
  isSuccessActivatePayment: boolean;
  handlerCancelProcedure: () => void;
  handlerClose: () => void;
  showModalAnulate: boolean;
  showModalPayment: boolean;
  showModalAnuledPayment: boolean;
  closeModalAnuledPayment: (value: boolean) => void;
  handlerClosePayment: () => void;
  handleAnulledState: () => void;
}

const RetreatCourseProgressView: React.FC<Props> = (props) => {
  const {
    handlerBackButton,
    request,
    procedure,
    procedureSelectedInfo,
    isLoadingStatus,
    isLoadingDetail,
    isActivating,
    isLoadingDelete,
    showModalPayment,
    showModalAnuledPayment,
    closeModalAnuledPayment,
    handlerClosePayment,
    handleAnulledState
  } = props;
  const { handlerActivatePayment } = props;
  const { isSuccessActivatePayment, handlerCancelProcedure } = props;
  const { handlerClose, showModalAnulate } = props;

  const history = useHistory();

  const evalStatus = () =>
    constants.procedureStatus.retreatCourse.find(
      (s: any) => s.name === request?.status.status
    );

  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);

  useEffect(() => {
    if (request) {
      const { requiresPayment, payed } = request;
      setIsPaymentActive(
        requiresPayment && evalStatus()?.name === 'PAGO_ACTIVADO' && !payed
      );
      setIsPaymentDone(requiresPayment && payed);
    }
  }, [request]);

  return (
    <ContainerProcedure>
      <SubContainer>
        <BackButton onClick={handlerBackButton} />
      </SubContainer>
      <div style={{ marginTop: '16px' }} />
      <Processing isOpen={isActivating} />
      <Processing isOpen={isLoadingDelete} />
      {(isLoadingStatus || isLoadingDetail) && <Spinner />}
      {!isLoadingStatus && !isLoadingDetail && procedure && (
        <SubContainer>
          <ToggleHeader
            isMigrated={procedure?.detail?.isMigrated}
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            status={request?.status}
            childContent={
              <ProcedureInfoComponent
                inRegister
                detail={procedureSelectedInfo?.detail}
              />
            }
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              date={procedure.steps[0].date?.toLowerCase()}
              isComplete
              isCurrent={procedure.steps[0].isCurrent}
            >
              <>
                <p>Resumen:</p>
                <ul
                  style={{
                    listStyle: 'disc',
                    listStylePosition: 'inside',
                    paddingLeft: '7px'
                  }}
                >
                  {procedure?.detail.enrolledCourses.map((item: any) => (
                    <li key={item.id}>{item.name}</li>
                  ))}
                </ul>
              </>
            </Step>
            <Step
              name={procedure?.steps[1]?.name}
              order={procedure?.steps[1]?.order}
              isComplete={
                request?.status.status === 'FINALIZADO' ||
                request?.status.status === 'PROCEDE'
              }
              disabled={
                evalStatus()?.name === 'ANULADO' ||
                request.status.status === 'NO_PROCEDE'
              }
            >
              <p>{procedure?.steps[1]?.date}</p>
              {evalStatus()?.name === 'CREADO' && (
                <CardPayment
                  title="Genera el cargo de tu trámite activando tu pago"
                  infoText="Recuerda que una vez realizado el pago, se procederá con tu solicitud."
                  buttonText="Activar"
                  isPaymentActive={isPaymentActive}
                  isPaymentDone={isPaymentDone}
                  handlerActivatePayment={handlerActivatePayment}
                  isLoadingActivatePayment={false}
                  isSuccessActivatePayment={isSuccessActivatePayment}
                  firstDialogSubtitle={`Al aceptar, se cargará el monto de S/${procedure?.amount}.00 a tus pagos pendientes.`}
                />
              )}
              {evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone && (
                <CardPayment
                  title="El pago ha sido activado"
                  infoText="La actualización del estado puede tardar aproximadamente 30 minutos tras el pago. Luego, comenzaremos a procesar tu solicitud."
                  buttonText="Ir a pagos"
                  isPaymentActive
                  isPaymentDone={isPaymentDone}
                  handlerActivatePayment={handlerActivatePayment}
                  isLoadingActivatePayment={false}
                  isSuccessActivatePayment={isSuccessActivatePayment}
                  secondDialogSubtitle={
                    'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
                  }
                />
              )}
              {evalStatus()?.name === 'PAGO_ACTIVADO' && isPaymentDone && (
                <>Pago en proceso</>
              )}
            </Step>
            <Step
              name={procedure?.steps[2]?.name}
              order={procedure?.steps[2]?.order}
              isComplete={evalStatus()?.isComplete}
              isLast
            >
              {evalStatus()?.name === 'PROCEDE' && (
                <>
                  <p>{procedure?.steps[2]?.date}</p>
                  <CardProgress
                    image={[documentSuccessImage, documentSuccessDskImage]}
                    title={`Tu solicitud ha sido aprobada`}
                  >
                    <div style={{ textAlign: 'left' }}>
                      <p>
                        En tu sección de cursos podrás validar tus cursos
                        retirados.
                      </p>
                    </div>
                  </CardProgress>
                </>
              )}

              {evalStatus()?.name === 'ANULADO' && (
                <AnulledFinalState procedure={procedure} />
              )}
            </Step>
          </Block>
          {((evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone) ||
            evalStatus()?.name === 'CREADO') && (
            <ButtonCancelRequest handlerShowAnulate={handleAnulledState} />
          )}
          <CancelProcedure
            handlerCancelProcedure={handlerCancelProcedure}
            handlerClose={handlerClose}
            show={showModalAnulate}
          />
          <Modal
            show={showModalAnuledPayment}
            handleClose={() => closeModalAnuledPayment(false)}
          >
            <ModalAnulled handleClick={() => closeModalAnuledPayment(false)} />
          </Modal>

          {isSuccessActivatePayment}
          <PaymentCreated
            show={showModalPayment}
            handlerOnNext={() => history.push(`/pagos`)}
            handlerClose={handlerClosePayment}
          />
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default RetreatCourseProgressView;
